function prettifySpeed(speedInBytes: number): string {
  const units = ['kbit/s', 'Mbit/s', 'Gbit/s', 'Tbit/s', 'Pbit/s']
  let speedInBits = speedInBytes * 8 // Convert bytes to bits
  let unitIndex = -1

  while (speedInBits >= 1000 && unitIndex < units.length - 1) {
    speedInBits /= 1000
    unitIndex++
  }

  // If the speed is less than 10, show it as a fraction
  const decimalPlaces = speedInBits < 10 ? 1 : 0

  return `${speedInBits.toFixed(decimalPlaces)} ${units[unitIndex >= 0 ? unitIndex : 0]}`
}

export default prettifySpeed
